export default {
  meta: {
    title: '点位评估报表'
  }
};

